<app-top-navigation></app-top-navigation>

<app-main-navigation></app-main-navigation>

<router-outlet></router-outlet>

<app-bottom-navigation></app-bottom-navigation>

<app-footer></app-footer>